module.exports = __webpack_public_path__ + "4e387da6561eea367fb46568f78883bb.jpg";